import {
  borderCss,
  mobileBorderCss,
  mobilePaddingsCss,
  paddingsCss,
  backgroundColorCss,
  mobileBackgroundColorCss,
} from 'common/utils/styleUtilsNew'
import {
  FormInterface,
  FormLayoutEnum,
} from 'src/shared/types/entities/form-interface'
import { css, styled } from 'styled-components'

export interface CommonFormUiProps
  extends Pick<
    FormInterface,
    | 'layout'
    | 'border'
    | 'mobileBorder'
    | 'padding'
    | 'mobilePadding'
    | 'backgroundColor'
    | 'mobileBackgroundColor'
  > {}

export const CommonFormUi = styled.form<CommonFormUiProps>`
  display: grid;
  gap: 10px;

  width: 100%;

  ${p =>
    p.layout === FormLayoutEnum.OneColumn
      ? 'grid-template-columns: 1fr;'
      : 'grid-template-columns: 1fr 1fr;'}

  ${borderCss}
  ${paddingsCss}
  ${backgroundColorCss}
  
  ${p => p.theme.phone} {
    grid-template-columns: 1fr;
    
    ${mobileBorderCss}
    ${mobilePaddingsCss}
    ${mobileBackgroundColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      grid-template-columns: 1fr;
      
      ${mobileBorderCss}
      ${mobilePaddingsCss}
      ${mobileBackgroundColorCss}
  `}
`
